import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { InspectionStatus } from "../../types/inspection";
import { createParametricSelectorHook } from "../../hooks/storeHooks";
import { getPhotoFolderValues } from "../../utils/imageHelper";

export const selectInspection = (state: RootState) => state.inspection;

export const selectInspectionData = (state: RootState) =>
    state.inspection.inspection;

export const selectInspectionId = (state: RootState) =>
    state.inspection.inspection?.id;

export const selectInspectionStatus = (state: RootState) =>
    state.inspection.inspection?.status;

export const selectInspectionEnableLowPriorityDefects = (state: RootState) =>
    state.inspection.inspection?.enableLowPriorityDefects;

export const selectPhotoFolders = (state: RootState) =>
    state.inspection.photoFolders;

export const selectImages = (state: RootState) => state.inspection.images;

export const selectLoadingImages = (state: RootState) =>
    state.inspection.loadingImages;

export const selectViewImages = (state: RootState) => 
    state.inspection.viewImages;

export const selectInspectionIsDisabled = createSelector(
    selectInspectionStatus,
    (inspectionStatus) =>
        inspectionStatus === InspectionStatus.FULL_REPORT ||
        inspectionStatus === InspectionStatus.CANCELLED
);

export const selectImagesByPhotoFolder = createParametricSelectorHook(
    createSelector(
        [
            selectImages,
            selectPhotoFolders,
            (_, photoFolder: string | null) => photoFolder
        ],
        (images, photoFolders, photoFolder) => {
            if (photoFolder) {
                const photoFolderValues = getPhotoFolderValues(
                    photoFolders,
                    photoFolder
                ).map((photoFolder) => photoFolder.Id);

                return images.filter((image) =>
                    photoFolderValues.includes(
                        Number(image.metadata["element-id"])
                    )
                );
            }

            return [];
        }
    )
);

export const selectGenerateItemsDialog = (state: RootState) => state.inspection.showGenerateItemsDialog;

export const selectSavingGrades = (state: RootState) => state.inspection.savingGrades;